var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_33007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60362 9.53663C5.6037 9.82185 5.66012 10.1042 5.76966 10.3676C5.8792 10.6309 6.0397 10.87 6.24193 11.0712C6.44416 11.2723 6.68414 11.4315 6.94808 11.5396C7.21202 11.6477 7.49472 11.7026 7.77994 11.7011C8.97356 11.6938 9.94331 10.7359 9.94387 9.56363C9.94649 9.27762 9.89219 8.99395 9.78414 8.72913C9.67608 8.46431 9.51643 8.22363 9.31447 8.0211C9.11252 7.81857 8.87229 7.65823 8.60778 7.54943C8.34327 7.44062 8.05976 7.38551 7.77375 7.38731C6.5745 7.389 5.60362 8.35031 5.60362 9.53663ZM5.60587 11.8654V12.5814H4.5V4.5C4.81444 4.50562 5.07994 4.61812 5.29312 4.84031C5.49731 5.05406 5.59912 5.31 5.598 5.607C5.59519 6.13969 5.59687 6.67237 5.59687 7.23038C6.36919 6.58519 7.22925 6.26737 8.23106 6.42037C9.22388 6.57225 9.98606 7.07175 10.5058 7.92619C11.2905 9.21712 11.0363 10.8658 9.89944 11.8918C8.79075 12.8931 6.94856 13.0483 5.60587 11.8654ZM9.18281 12.5668C9.22669 12.5404 9.24975 12.5246 9.27394 12.5122C9.62228 12.3411 9.93674 12.1082 10.2021 11.8249C10.2289 11.7944 10.2617 11.7697 10.2985 11.7524C10.3353 11.735 10.3752 11.7255 10.4158 11.7242C11.3552 11.6702 12.2018 10.9142 12.3609 9.98944C12.5702 8.77444 11.8322 7.70231 10.6116 7.46944C10.4439 7.44406 10.2905 7.36041 10.1784 7.23319C9.95344 6.98456 9.68006 6.7905 9.38925 6.62344C9.3645 6.60937 9.34088 6.59419 9.30037 6.56944C9.85388 6.41756 10.3933 6.38156 10.9401 6.50588C11.484 6.62906 11.9526 6.89569 12.3913 7.25962V6.54244H13.5V14.625C13.3527 14.6241 13.207 14.5937 13.0717 14.5355C12.9363 14.4773 12.814 14.3926 12.7119 14.2864C12.611 14.1847 12.5315 14.0638 12.4782 13.9309C12.4248 13.7979 12.3987 13.6556 12.4014 13.5124V11.898C11.4463 12.6984 10.3899 12.9381 9.18281 12.5668Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_33007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBq);
export default __webpack_public_path__ + "static/media/bq.61da38c0974d3e72a013a0b180d4eedc.svg";
export { ForwardRef as ReactComponent };